import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { LicenseManagementComponent } from './license-management.component';


export { LicenseManagementModule } from './license-management.module';
export const ngxLicenseManagementModule = angular.module('ngxLicenseManagementModule', [])
	.directive('ngxLicenseManagement', downgradeComponent({component: LicenseManagementComponent})).name;
